import { SapiEntity } from '../services/sapi.service';

export enum AdScheduleMidrollIntervalUnit {
	seconds = 'seconds',
	percent = 'percent'
}
interface AdScheduleVastItem {
	id: string;
	vast_url?: string;
	auction_id?: string;
}
interface AdSchedulePosition {
	skippable: boolean;
	items: AdScheduleVastItem[];
}
interface AdSchedulePositionMidroll extends AdSchedulePosition {
	interval: number;
	intervalUnit: AdScheduleMidrollIntervalUnit;
	useSceneAlignment?: boolean;
}
export interface AdSchedule extends SapiEntity {
	title?: string;
	description?: string;
	playoutCodes?: string[];
	preroll: AdSchedulePosition;
	midroll: AdSchedulePositionMidroll;
	postroll: AdSchedulePosition;
}
export interface AdScheduleStatsCollection {
	[adScheduleCode: string]: AdScheduleStats;
}
export interface AdScheduleStats {
	inits?: number;
	inview?: number;
	inview_compare?: number;
	placement_failed?: number;
	placement_failed_compare?: number;
	inits_compare?: number;
	creative_inits?: number;
	creative_inits_compare?: number;
	views?: number;
	views_compare?: number;
	clicks?: number;
	clicks_compare?: number;
	creative_fillrate?: number;
	creative_fillrate_compare?: number;
	fillrate?: number;
	fillrate_compare?: number;
	fillrateInview?: number;
	fillrateInview_compare?: number;
	placementFailedRate?: number;
	placementFailedRate_compare?: number;
	placementRate?: number;
	placementRate_compare?: number;
	clickrate?: number;
	clickrate_compare?: number;
	inventory?: number;
	inventory_compare?: number;
}
